import { Capacitor } from '@capacitor/core'
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics'

export const analytics = {
    setScreenName: ({ screenName, screenClass = 'Page' }) => {
        if (!Capacitor.isNativePlatform()) {
            return
        }
        if (screenName) {
            return FirebaseAnalytics.setScreenName({
                screenName,
                nameOverride: screenClass,
            })
        }
    },
    setUserProperty: ({ name, value }) => {
        if (!Capacitor.isNativePlatform()) {
            return
        }
        return FirebaseAnalytics.setUserProperty({
            name,
            value,
        })
    },
    setRoles: (roles) => {
        if (!Capacitor.isNativePlatform()) {
            return
        }
        return FirebaseAnalytics.setUserProperty({
            name: 'userType',
            value: roles.join('|'),
        })
    },
}
